<template>
  <el-col :span="12">
    <el-row type="flex">
      <h4>메일 전송 세부 설정</h4>
    </el-row>
    <el-form :model="formData">
      <el-form-item label="보내는 사람" class="regist-wizard-form-title">
        <el-input size="small" v-model="formData.smtpSenderId" placeholder="보내는 사람의 아이디를 입력해주세요"></el-input>
      </el-form-item>
      <el-form-item label="받는 사람" class="regist-wizard-form-title">
        <el-input size="small" v-model="formData.smtpReceiverId" placeholder="받는 사람의 아이디를 입력해주세요"></el-input>
      </el-form-item>
      <el-form-item label="참조" class="regist-wizard-form-title">
        <el-input size="small" v-model="formData.smtpCcId" placeholder="참조 값을 입력해주세요"></el-input>
      </el-form-item>
      <el-form-item label="메일 내용" class="regist-wizard-form-title">
        <el-input type="textarea" v-model="formData.smtpContext" rows="7" placeholder="메일 내용을 입력해주세요"></el-input>
      </el-form-item>
    </el-form>
  </el-col>
</template>

<script>
export default {
  name: 'WE2eMailSettingForm',
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {

    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>
.regist-wizard-form-title {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/components/E2eMailSettingForm.vue